/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/awardFinder/resources/js/homePage/numbersFieldUtil.js
*    TO   --> ./webapps/homepage-web/src/main/assets/js/home/award-finder/numbers-field-util.js
**/

var NumbersFieldUtil = {};

NumbersFieldUtil = (function() {

	var _$searchForm = $('#searchRequestForm');
	var _$milesInput = _$searchForm.find('input[name="miles"]');

	function initializeMilesFieldBehavior() {
		blockNonNumericInput();
		formatNewNumber();
		enterDefaultMilesIfBlankOnSubmitAndBlur();
		removeNbspCharacterForFrench();
	}

	var blockNonNumericInput = function(){
		$(".numbers").keydown(function(event) {
        	// Allow: backspace, delete, tab, escape, and enter
        	if ( event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 27 || event.keyCode == 13 || 
             	// Allow: Ctrl+A
            	(event.keyCode == 65 && event.ctrlKey === true) || 
             	// Allow: home, end, left, right
            	(event.keyCode >= 35 && event.keyCode <= 39)) {
            		// let it happen, don't do anything
            		return;
        		} else {
        			// Ensure that it is a number and stop the keypress
        			if (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105 )) {
            			event.preventDefault(); 
       				}
    			}
    	});
    };

    var formatNewNumber = function(){
		$(".numbers").keyup(function(){
			if($(this).val() == '') {
				return;
			}
			else {
				var country = getLocaleCountry();
    			$(this).parseNumber({format:"#,###", locale:country});
    			$(this).formatNumber({format:"#,###", locale:country});
    		}
	 	});
	};

	var enterDefaultMilesIfBlankOnSubmitAndBlur = function() {
		_$searchForm.submit(function() {
			enterDefaultValueInMilesInputIfEmpty();
		});
		_$milesInput.blur(function() {
			enterDefaultValueInMilesInputIfEmpty();
		});
		
		
	};

	var enterDefaultValueInMilesInputIfEmpty = function() {
		if( _$milesInput.val() == '') {
			var country = getLocaleCountry();
			_$milesInput.val(_$milesInput.attr('data-default'));
			_$milesInput.formatNumber({format:"#,###", locale:country});
		}
	};

	var removeNbspCharacterForFrench = function() {
		if (getLocaleCountry() === 'fr') {
			var re = new RegExp(String.fromCharCode(160), "g");
			_$milesInput.val(_$milesInput.val().replace(re, ' '));
		}
	}

	var getLocaleCountry = function() {
		var country = AAcom.prototype.getProperty('userLocale').substring(3, 5).toLowerCase();
		if (country === 'ca' && AAcom.prototype.getProperty('userLocale').substring(0,2) === 'fr') {
			country = 'fr';
		}
		return country;
	}

	return {
		initializeMilesFieldBehavior : initializeMilesFieldBehavior,
		enterDefaultValueInMilesInputIfEmpty : enterDefaultValueInMilesInputIfEmpty
	};

}());
